import React from "react";
import StarRatings from "react-star-ratings";
import { moment, renderNumberGreaterThan100 } from "../common/common";

import { getCarReviews } from "../../model/car";
import { commonErr } from "../common/errors";
import { Empty } from "../common/messagebox";

import { IcStarRating } from "../common/svg";

import empty from "../../static/images/empty/empty-review.svg";
import avatar_default from "../../static/images/avatar_default.png";

const reviewTime = (time) => {
	if (moment().isSame(time, "year")) {
		return moment(time).format("DD/MM");
	} else {
		return moment(time).format("YYYY");
	}
};

export const Reviews = ({ review, reviewProfile }) => {
	const onProfileUrl = () => {
		const state = {
			isOwner: false,
			isReview: true,
			isTrip: false,
		};
		// window.history.pushState(state, '', `/profile/${uid}`)
		localStorage.setItem("info", JSON.stringify(state));
	};
	return (
		<div className="item-review">
			<div className="profile">
				<div className="desc">
					{!review.avt && reviewProfile && (
						<a href={`/profile/${reviewProfile.uid}`} onClick={() => onProfileUrl()} className="avatar avatar--m">
							<img
								loading="lazy"
								src={
									reviewProfile.avatar && reviewProfile.avatar.thumbUrl ? reviewProfile.avatar.thumbUrl : avatar_default
								}
								onError={(e) => {
									e.target.onerror = null;
									e.target.src = avatar_default;
								}}
								alt="Mioto - Thuê xe tự lái"
							/>
						</a>
					)}
					{review.avt && review.avt !== "" && (
						<div className="avatar avatar--m">
							<img
								loading="lazy"
								src={review.avt}
								onError={(e) => {
									e.target.onerror = null;
									e.target.src = avatar_default;
								}}
								alt="Mioto - Thuê xe tự lái"
							/>
						</div>
					)}
					<div className="info">
						{/* <span className="tag-item transmission">{review.serviceType === 1 ? "Xe tự lái" : "Xe có tài"} </span> */}
						{!review.name && reviewProfile && (
							<a href={`/profile/${reviewProfile.uid}`} onClick={() => onProfileUrl(reviewProfile.uid)}>
								<h6>{reviewProfile.name}</h6>
							</a>
						)}
						{review.name && review.name !== "" && <h6 className="name">{review.name}</h6>}
						<div className="rate">
							<StarRatings rating={review.rating} starRatedColor="#FFC634" starDimension="17px" starSpacing="1px" />
							<p className="time">{reviewTime(review.timeCreated)}</p>
						</div>
					</div>
				</div>
			</div>
			{review.comment && <pre className="main-review">{review.comment}</pre>}
		</div>
	);
};

class CarReviews extends React.Component {
	constructor() {
		super();
		this.state = {
			err: commonErr.INNIT,
			reviews: [],
			profiles: [],
			more: 0,
			totalReviews: 0,
		};
	}

	componentDidMount() {
		const { reviews, profiles, info, moreReview } = this.props.detail;
		const { totalReviews } = info;

		if (!reviews || !profiles) {
			if (totalReviews > 0) {
				getCarReviews(this.props.detail.info.id, 0, 0, 0).then((resp) => {
					if (resp.data.data && resp.data.data.reviews && resp.data.data.profiles) {
						this.setState({
							err: resp.data.error,
							reviews: this.state.reviews.concat(resp.data.data.reviews),
							profiles: this.state.profiles.concat(resp.data.data.profiles),
							more: resp.data.data.more,
							totalReviews: resp.data.data.totalReviews,
						});
					}
				});
			}
		} else {
			this.setState({
				reviews: this.state.reviews.concat(reviews),
				profiles: this.state.reviews.concat(profiles),
				more: moreReview,
				totalReviews: totalReviews,
			});
		}
	}

	getMoreReviews = () => {
		getCarReviews(this.props.detail.info.id, 0, this.state.reviews.length, 0).then((resp) => {
			if (resp.data.data && resp.data.data.reviews && resp.data.data.profiles) {
				this.setState({
					err: resp.data.error,
					reviews: this.state.reviews.concat(resp.data.data.reviews),
					profiles: this.state.profiles.concat(resp.data.data.profiles),
					more: resp.data.data.more,
					totalReviews: resp.data.data.totalReviews,
				});
			}
		});
	};

	render() {
		const car = this.props.detail.info;
		const { reviews, more, profiles } = this.state;

		return (
			<div className="info-car-desc">
				{/* <h6>Đánh giá</h6> */}
				{car.totalReviews > 0 ? (
					<div className="reviews">
						<div className="rate-review">
							<div className="wrap-svg">
								<IcStarRating />
							</div>
							<p className="rate">{car.rating.avg.toFixed(1)}</p>
						</div>
						<span className="dot">•</span>
						<p className="total-review">{renderNumberGreaterThan100(car.totalReviews)} đánh giá</p>
					</div>
				) : (
					<Empty msg={"Chưa có đánh giá"} img={empty} />
				)}
				{car.totalReviews > 0 && reviews && (
					<div className="list-reviews">
						{reviews.map((review, i) => {
							var reviewProfile;
							if (profiles.length > 0) {
								for (var i = 0; i < profiles.length; ++i) {
									if (profiles[i].uid === review.uid) {
										reviewProfile = profiles[i];
										break;
									}
								}
							}
							return <Reviews key={review.id} review={review} reviewProfile={reviewProfile} />;
						})}
					</div>
				)}
				{more == true && (
					<div className="btn-see-more">
						<a onClick={this.getMoreReviews} className="btn btn--s btn-secondary">
							Xem thêm
						</a>
					</div>
				)}
			</div>
		);
	}
}

export default CarReviews;
